import { apiClient } from './base'
import type { UsageLimits } from '@/types/usage'

class UsageService {
    private useMock = import.meta.env.VITE_USE_MOCK_API !== 'false'

    async getLimits(): Promise<UsageLimits> {
        if (this.useMock) {
            const leadsLimit = Number(import.meta.env.VITE_USAGE_LEADS_LIMIT) || 1000
            const searchLimit = Number(import.meta.env.VITE_USAGE_SEARCH_LIMIT) || 250

            const now = new Date()
            const resetDay = 15
            let nextResetDate = new Date(now.getFullYear(), now.getMonth(), resetDay)
            if (now.getDate() >= resetDay) {
                nextResetDate = new Date(now.getFullYear(), now.getMonth() + 1, resetDay)
            }
            nextResetDate.setHours(0, 0, 0, 0)

            return {
                total_leads: { current: 0, limit: leadsLimit, unlimited: false },
                lead_search: {
                    current: 0,
                    limit: searchLimit,
                    unlimited: false,
                    reset_date: nextResetDate.toISOString()
                }
            }
        }

        // apiClient.request faz `{ success: true, ...data, message }`,
        // então o body do backend (total_leads/lead_search) fica spread no topo,
        // não em `response.data`. Lemos direto.
        const response = (await apiClient.get<UsageLimits>('/usage/limits')) as any
        if (!response?.total_leads || !response?.lead_search) {
            throw new Error('Resposta inválida de /usage/limits')
        }
        return {
            total_leads: response.total_leads,
            lead_search: response.lead_search
        }
    }

    async incrementSearchCount(count: number = 1, metadata?: Record<string, any>): Promise<void> {
        if (this.useMock) return
        await apiClient.post('/usage/increment/leads', { count, metadata })
    }
}

export const usageService = new UsageService()
